import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AppState, TargetType, Origin, ProcessState, Position } from '../../store/appMode';
import * as actionTypes from '../../store/actions/action-types';
import Button, { ButtonWithTransition } from '../../components/Button/Button';
import classNames from 'classnames';
import ProcessButton from '../../components/ProcessButton/ProcessButton';
import Popup from '../../components/Popup/Popup';
import { MultiItemBoxWithTransition } from '../MultiItemBox/MultiItemBox';
import { ReactComponent as SlidersIcon } from '../../../../../icons/dpit-sliders-h-solid.svg';
import { ReactComponent as EllipsisIcon } from '../../../../../icons/dpit-ellipsis-h-solid.svg';
import { ReactComponent as CloseCrossIcon } from '../../../../../icons/dp-close-cross.svg';


import '../../components/Button/dpit-button-exit.scss';
import '../../containers/MultiItemBox/dpit-box-sub-item.scss';
import '../../components/Button/dpit-button-close-popup.scss';

const i18n = window.dpIntroTourPublicConfig.i18n;


import './dpit-controls.scss';


class BuilderControls extends Component {


	editStep = () => {
		this.props.setAppState(AppState.PANEL_EDIT);
	};

	getCloseButtonTitle = () => {
		if (this.props.appState === AppState.TARGET_SELECTION)
			return this.props.targetType === TargetType.STEP ? i18n.cancel_sel_target_step : i18n.cancel_sel_target_trigger;
		//else if ((this.props.appState === AppState.VIEW)) return this.props.origin === Origin.FRONTEND ? i18n.exit_builder : i18n.exit_builder_admin;
		return '';
	};

	changeTriggerSelector = () => {
		this.props.setAppState(AppState.TARGET_SELECTION);
	};

	render() {

		const closeMultiItemBox = (
			<MultiItemBoxWithTransition
				classBEMRoot='dpit-multi-item-box'
				className={classNames({
					'dpit-controls__multi-close': true,
					'dpit-controls__multi-close--bottom-left': this.props.cancelButtonAltPos
						&& this.props.appState === AppState.TARGET_SELECTION
				})}
				externalState={true}
				isOpened={this.props.isCloseMenuOpened}
				onOpenChange={this.props.updateCloseMenuOpened}
				//openDisabled={this.props.appState === AppState.TARGET_SELECTION}

				active={!this.props.disableCloseButton
					&& this.props.appState !== AppState.PANEL_EDIT
					&& this.props.appState !== AppState.PAUSE
					&& this.props.appState !== AppState.PAUSE_TARGET_SEL_1_CLICK
					&& this.props.appState !== AppState.CANCEL
					&& this.props.appState !== AppState.REDIRECT_MODAL_OPENED
					&& this.props.appState !== AppState.PROMO_MODAL_OPENED
					&& this.props.appState !== AppState.TMCE_MODAL_OPENED
					&& (this.props.savingState !== ProcessState.PROCESSING
						|| this.props.appState === AppState.TARGET_SELECTION)
					&& !this.props.mainCfg.mobileAltStepMode
					&& (!(this.props.targetType === TargetType.MOBILE_MENU && this.props.mainCfg.inNewWindow)
						|| this.props.appState === AppState.TARGET_SELECTION)
				}
			>
				<Button
					classBEMRoot='dpit-button-exit'
					className={classNames({
						'dpit-button-exit--alt': this.props.appState === AppState.TARGET_SELECTION
					})}
					onClick={() => { this.props.updateCloseMenuOpened(!this.props.isCloseMenuOpened); }}
					title={this.getCloseButtonTitle()}
					active={true}
				>
					{
						this.props.appState === AppState.TARGET_SELECTION
							? <CloseCrossIcon className={'dpit-button-exit__icon'} />
							: <EllipsisIcon className={'dpit-button-exit__icon'} />
					}
				</Button>
				<ButtonWithTransition
					classBEMRoot='dpit-box-sub-item'
					className='dpit-controls__button--cancel-sub dp-target-sel-bl'
					active={this.props.appState === AppState.TARGET_SELECTION}
					text={i18n.exit_target_selection}
					onClick={() => { this.props.onCancelButtonClick(); }}
				/>
				<ButtonWithTransition
					classBEMRoot='dpit-box-sub-item'
					className='dpit-controls__button--cancel-sub dp-target-sel-bl'
					active={this.props.appState === AppState.TARGET_SELECTION}
					text={i18n.move_this_button}
					onClick={() => { this.props.toggleCancelButtonPos(); }}
				/>

				<ButtonWithTransition
					classBEMRoot='dpit-box-sub-item'
					className='dpit-controls__button--cancel-sub dp-target-sel-bl'
					active={this.props.appState === AppState.TARGET_SELECTION}
					text={i18n.pause_1_click}
					onClick={() => { this.props.setAppState(AppState.PAUSE_TARGET_SEL_1_CLICK); }}
				/>

				<ButtonWithTransition
					classBEMRoot='dpit-box-sub-item'
					className='dpit-controls__button--cancel-sub'
					active={this.props.appState !== AppState.TARGET_SELECTION}
					text={i18n.hide_builder_controls}
					onClick={() => { this.props.onHideControlsClick(); }}
				/>
				<ButtonWithTransition
					classBEMRoot='dpit-box-sub-item'
					className='dpit-button-exit--slower-opacity'
					active={this.props.appState !== AppState.TARGET_SELECTION && this.props.targetType === TargetType.STEP}
					text={i18n.go_to_tour_cfg}
					onClick={() => { this.props.onCancelButtonClick(Origin.ADMIN); }}
				/>
				<ButtonWithTransition
					classBEMRoot='dpit-box-sub-item'
					className='dpit-controls__button--cancel-sub dpit-button-exit--slower-opacity'
					active={this.props.appState !== AppState.TARGET_SELECTION && this.props.targetType === TargetType.STEP}
					text={this.props.mainCfg.isAdmin ? i18n.exit_c : i18n.exit_to_frontend}
					onClick={() => { this.props.onCancelButtonClick(Origin.FRONTEND); }}
				/>
				<ButtonWithTransition
					classBEMRoot='dpit-box-sub-item'
					className='dpit-controls__button--cancel-sub dpit-button-exit--slower-opacity'
					active={this.props.appState !== AppState.TARGET_SELECTION && this.props.targetType !== TargetType.STEP}
					text={i18n.cancel}
					onClick={() => { this.props.onCancelButtonClick(this.props.origin); }}
				/>


			</MultiItemBoxWithTransition>
		);

		return (
			<div className={classNames({
				'dpit-controls': true,
				['dpit-controls--' + this.props.controlsPosition.toLowerCase()]: true
			})}>
				<ButtonWithTransition
					classBEMRoot='dpit-controls__button'
					className='dpit-controls__button--add-first-step margin-based-transition-350'
					active={![
						AppState.TARGET_SELECTION,
						AppState.CANCEL,
						AppState.REDIRECT_MODAL_OPENED,
						AppState.INIT,
						AppState.REDIRECTING,
						AppState.PROMO_MODAL_OPENED,
						AppState.PAUSE
					].includes(this.props.appState)
						&& this.props.targetType === TargetType.STEP
						&& this.props.stepCount <= 0
					}
					onClick={this.props.addNewStepAfterFce}
					text={i18n.add_first_step}
				/>
				<ButtonWithTransition
					classBEMRoot='dpit-controls__button'
					className='dpit-controls__button--pause-builder'
					active={this.props.appState === AppState.PAUSE}
					onClick={() => { this.props.onHideControlsClick(); }}
					text='&#9654;'
					title=''
				/>
				<div className="dpit-controls__wrap">
					<ProcessButton
						classBEMRoot='dpit-controls__button'
						className={classNames({
							'dpit-controls__button--save': true,
							'margin-based-transition-120': this.props.targetType === TargetType.STEP,
							'margin-based-transition-250': this.props.targetType === TargetType.TRIGGER,
						})}
						active={(this.props.isChange || this.props.savingState !== ProcessState.IDLE)
							&& this.props.appState !== AppState.TARGET_SELECTION
							&& this.props.appState !== AppState.PAUSE
							&& this.props.appState !== AppState.PAUSE_TARGET_SEL_1_CLICK

							&& (
								(this.props.appState !== AppState.CANCEL
									&& this.props.appState !== AppState.PROMO_MODAL_OPENED
									&& this.props.appState !== AppState.REDIRECT_MODAL_OPENED
									&& this.props.appState !== AppState.TMCE_MODAL_OPENED)
								|| (this.props.savingState !== ProcessState.IDLE))
						}
						onClick={this.props.onSaveChangesButtonClick}
						text={this.props.targetType === TargetType.STEP ? i18n.save_changes : i18n.save_changes_exit}
						processedText={i18n.saved}
						errorText={i18n.saving_failed}
						processState={this.props.savingState}
						animClockPeriodMs={100}
						animClassBEMRoot='dpit-anim-rb-builder'
						animClassName={'dpit-controls__running-bullets-anim'}
						animCount={5}
						resultTimeoutMs={2000}
					/>
					<ButtonWithTransition
						classBEMRoot='dpit-controls__button'
						className='dpit-controls__button--edit-step margin-based-transition margin-based-transition-58'
						active={!this.props.disableEditButton && this.props.appState === AppState.VIEW && this.props.stepCount > 0 && this.props.targetType === TargetType.STEP}
						onClick={this.editStep}
						title={i18n.edit}
						noSpan={true}
					>
						<SlidersIcon className={'dpit-controls__button__icon'} />
					</ButtonWithTransition>
					<ButtonWithTransition
						classBEMRoot='dpit-controls__button'
						className='dpit-controls__button--change-selection margin-based-transition margin-based-transition-120'
						active={this.props.appState !== AppState.TARGET_SELECTION
							&& this.props.appState !== AppState.CANCEL
							&& this.props.appState !== AppState.PAUSE
							&& this.props.appState !== AppState.PAUSE_TARGET_SEL_1_CLICK
							&& (this.props.targetType === TargetType.TRIGGER || this.props.targetType === TargetType.MOBILE_MENU)
							&& this.props.savingState === ProcessState.IDLE
						}
						onClick={this.changeTriggerSelector}
						text={i18n.change_your_sel}
					/>

					<Popup
						classBEMRoot="dpit-popup-hint"
						className="dpit-controls__hint-popup"
						closeButtonClass="dpit-button-close-popup"
						keyId={'hint_popup'}
						closeButtonTitle={i18n.close_hint}
						onCloseClick={this.props.closeHint}
						{...this.props.hintConfig}
					>
						{
							this.props.hintConfig.cta ?
								<Button
									classBEMRoot='dpit-popup-hint__content__cta'
									className='dpit-controls__hint-popup__cta'
									text={this.props.hintConfig.cta}
									onClick={this.props.hintCtaClick}
									active={true}
								/>
								: null
						}
						{
							this.props.hintConfig.afterCtaText ?
								<div
									className='dpit-popup-hint__content__after-cta'
								>{this.props.hintConfig.afterCtaText}</div>
								: null
						}
					</Popup>
					{this.props.controlsPosition === Position.TOP ? closeMultiItemBox : null}
				</div>
				{this.props.controlsPosition === Position.BOTTOM ? closeMultiItemBox : null}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	appState: state.app.appState,
	hintConfig: state.app.hintConfig,
	targetType: state.app.targetType,
	origin: state.app.origin,
	isChange: state.app.isChange,
	savingState: state.app.savingState,
	stepChanges: state.app.stepChanges,
	stepCount: state.app.stepCount,
	controlsPosition: state.app.controlsPosition,
	stepItem: state.app.stepItem,
	mobileAltStepMode: state.app.mobileAltStepMode,
	cancelButtonAltPos: state.app.cancelButtonAltPos,
	isCloseMenuOpened: state.app.isCloseMenuOpened
});

const mapDispatchToProps = dispatch => {
	return {
		setAppState: (appState) => dispatch({ type: actionTypes.SET_APP_STATE, appState: appState }),
		setTargetType: (targetType) => dispatch({ type: actionTypes.SET_APP_EDIT_TARGET_TYPE, targetType: targetType }),
		closeHint: () => dispatch({ type: actionTypes.CLOSE_HINT }),
		toggleCancelButtonPos: () => dispatch({ type: actionTypes.TOGGLE_CANCEL_BUTTON_POS }),
		updateCloseMenuOpened: (isOpened) => dispatch({ type: actionTypes.UPDATE_CLOSE_MENU_OPENED, isOpened: isOpened }),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(BuilderControls);


